import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'
import { DocumentGsForm } from '../../utils/document-gs-form'
import PulseFilesUploader from '@app/application/pulse/pulse-files-uploader'

// This is a bit of a mess, jQuery, Vue, triggered from a rails js.erb partial.
// This JS initially in view_components folder and was coffeescript:
// https://gitlab.silverfin.com/development/silverfin/-/blob/48e3d402a1e6edf73d17793347b226a7d41fd739/app/view_components/assets/javascripts/document/uploader.js.coffee
//
// TODO: Next time we add a feature to this we should move it all to proper Vue components, including the uploader.scss
export default class Uploader {
  constructor(modal) {
    this.$modal = $(modal)
    this.$submit = this.element('submit')

    this.updateSubmitButtonStatus()

    this.$category = this.element('category')
    this.$footer = this.element('footer')
    this.$folders = this.element('folders')
    this.$folder = this.element('folder')

    if (this.foldersCount() === 1) {
      // auto pick folder when only one
      this.setFolder(this.firstFolder())
    }

    if (this.foldersCount() <= 1) {
      // don't show folders if less than 2
      this.$folders.addClass('sf-hidden')
      this.$folder.addClass('sf-hidden') // and hide footer as well in that case (until we upload a file)
    }

    this.addListeners()
  }

  addListeners() {
    this.$modal.on('click', this.behaviour('folder'), (event) => {
      if (this.$footer.hasClass('sf-disabled')) return
      this.$folder.removeClass('selected')
      this.setFolder(this.find(event.currentTarget))
    })

    this.$modal.on('click', this.behaviour('submit'), () => {
      this.sendForm()
    })

    this.$modal.find("[data-behaviour~='pulse-files-upload']").each((_, el) => {
      this.addModal(el)
    })
  }

  addModal(element) {
    const data = $(element).data()
    const form = document.querySelector(
      "[data-behaviour~='pulse-files-upload-form']"
    )
    const $form = $(form)
    const paramsPrefix = data.paramsPrefix
    const documentsForm = new DocumentGsForm(form, paramsPrefix)

    const handleFileUploaded = ({ blob }, uuid) => {
      documentsForm.addInputs(
        uuid,
        blob.signed_id,
        blob.filename,
        blob.content_type,
        blob.byte_size
      )

      this.$footer.removeClass('sf-disabled sf-hidden')
      $('[data-behaviour~="document-uploader-before-upload"]').hide()
      $('[data-behaviour~="document-uploader-after-upload"]').show()
    }

    const handleFileRemoved = (uuid) => {
      $form.find(`[data-id="${uuid}"]`).remove()
    }

    const handleAllFilesUploaded = (bool) => {
      if (bool) {
        this.$submit.removeClass('sf-disabled')
      } else {
        this.$submit.addClass('sf-disabled')
      }
    }

    createApp(PulseFilesUploader, {
      accept: data.accept,
      onFileUploaded: handleFileUploaded,
      onFileRemoved: handleFileRemoved,
      onAllFilesUploaded: handleAllFilesUploaded,
    }).mount(element)
  }

  removeModal() {
    this.$modal.hide()
    this.$modal.remove()
  }

  sendForm() {
    if (this.sending) {
      return
    }
    const $form = this.element('form')
    $form.find("[name='pulse_upload_folder_id']").val(this.folderID)
    $form.on('ajax:success', () => {
      this.removeModal()
    })
    $form.submit()
    this.sending = true
  }

  setFolder($folder) {
    this.folder = $folder.data('title')
    this.folderID = $folder.data('id')
    $folder.addClass('selected')
    this.$category.html(this.folder)
    this.updateSubmitButtonStatus()
  }

  updateSubmitButtonStatus() {
    if (this.folder) {
      this.$submit.removeClass('sf-disabled sf-hidden')
    } else {
      this.$submit.addClass('sf-disabled sf-hidden')
    }
  }

  foldersCount() {
    return this.$folder.length
  }

  firstFolder() {
    return this.find(this.$folder[0])
  }

  // =======
  // Helpers
  //

  find(selector) {
    return this.$modal.find(selector)
  }
  element(behaviour) {
    return this.find(this.behaviour(behaviour))
  }
  behaviour(behaviour) {
    return `[data-behaviour~='document-uploader-${behaviour}']`
  }
}
